import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import Multiselect from './components/Multiselect';
import { Button, Stack } from '@mui/material';
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh, apps }) => {
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [description,setDescription] = useState(data.description)
  const uploadImage = useUploadImage()



  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const appOptions = apps?.map(item => ({
    label: item?.name,
    value: item?.app_id,
  }))


const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setProcessing(true);

  let image_response = null;

  // Upload new image only if selected
  if (selectedFile) {
      image_response = await uploadImage({
          file: selectedFile,
          desiredPath: `app/logo/image`,
      });
  }

  // Ensure all required fields are present
  const payload = {
      name: e.target.name?.value?.trim() || "",  // Ensure string values
      description,
      website: e.target.website?.value?.trim() || "",
      video: e.target.video?.value?.trim() || "",
      image: image_response?.response?.data || data.image || "", 
      app: e.target.app?.value || "",
      type: e.target.type.value || "",
  };



     const { response } = await AppService.partner.update({
      query: `id=${data._id}`, // Send `_id` in query
      payload, // Send only the updated fields in the request body
  });

      if (response) {
          setProcessing(false);
          setOpenEditProduct(false);
          handleRefresh();
      }
};




  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Tag
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">App ID</MDTypography>
              <MDInput label="app_id" name="app" fullWidth defaultValue={data.app} />
            </MDBox>





            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description}/>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Website</MDTypography>
              <MDInput label="website" name="website" fullWidth defaultValue={data.website}/>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video</MDTypography>
              <MDInput label="Video" name="video" fullWidth defaultValue={data.video}/>
            </MDBox>
 
              <MDBox mb={2}>
                            <MDTypography variant="button">Type</MDTypography>
                            <MDInput
                              select
                              name="type"
                              defaultValue={data.type}
                              fullWidth
                              required
                              SelectProps={{ native: true }}
                            >
                              <option value="" disabled>
                                Select a Type
                              </option>
                              <option value="Level 1">Level 1</option>
                              <option value="Level 2">Level 2</option>
                              <option value="Level 3">Level 3</option>
                            </MDInput>
                          </MDBox>


            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Add Logo
                <input hidden name="image" type="file" onChange={handleFileChange}/>
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
